import apiClient from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { getHublet } from '../store/app/selectors';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { isNewLoggedInAccount } from '../http/endpointStateChecks';
import { getIsActiveAndAssignedToVariant } from '../store/experiments/selectors';
export const shouldAssignToTrellisGate = state => {
  const isAssignedToACQ176VariantA = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0176, [ExperimentParameterGroup.Variant_A]);
  return isNewLoggedInAccount(state) && isAssignedToACQ176VariantA;
};
export const assignToTrellisGate = state => {
  const url = `${getFullUrl('api', {
    hubletOverride: getHublet(state)
  })}/gating/app/v1/app/ungate/gate/trellis:always-on`;
  return apiClient.post(url);
};